import { useMutation } from "react-query";
import { fetchBlack5ProductList, fetchProductSearchV3 } from ".";

export const useBlack5ProductList = () => useMutation(fetchBlack5ProductList);

export const useProductSearchV3 = () => useMutation(fetchProductSearchV3);
